export default "__VITE_ASSET__d190dd38__"